// src/features/passwords/utils/pagination.js

/**
 * Simple array pagination helper.
 * Returns a slice for the given page and page size.
 */
function paginate(items, currentPage, perPage) {
    const start = (currentPage - 1) * perPage;
    if (!Array.isArray(items) || perPage <= 0) return [];
    return items.slice(start, start + perPage);
  }
  
  export default paginate;      // <-- default export
  export { paginate };          // <-- also export named for convenience
  